import { z } from 'zod';
import { c } from '../../contract';

const featureFlagName = z.string();
const isEnabled = z.boolean();

export const featureFlagsRouter = c.router(
  {
    getFeatureFlags: {
      path: '/',
      method: 'GET',
      query: z.object({
        deviceId: z.string(),
      }),
      responses: {
        200: z.object({
          featureFlags: z.record(featureFlagName, isEnabled),
        }),
      },
    },
  },
  {
    pathPrefix: '/feature-flags',
  },
);
